import { useAccount } from '@bnnvara/accounts';
import { useBrand } from '@bnnvara/brand';
import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import MediaPlayerEmbed from '../components/MediaPlayerEmbed';

export const Theater = styled.div`
  width: 100%;
  height: 100%;
  background: black;
  max-height: ${(props) => (props.mediaType === 'audio' ? '70px' : '638px')};
`;

const ComposableMediaPlayer = ({
  media: { id, mediaType, title },
  theaterMode,
}) => {
  const brand = useBrand();
  const {
    profile: { UID },
  } = useAccount();

  const player = (
    <MediaPlayerEmbed
      id={id}
      type={mediaType}
      title={title}
      atInternetId={brand.atInternetId}
      siteName={brand.slug}
      userId={UID}
    />
  );

  if (theaterMode) {
    return <Theater>{player}</Theater>;
  }

  return (
    <GridItem
      columnStartSm="1"
      columnEndSm="span 12"
      columnStartMd="2"
      columnEndMd="span 10"
      columnStartLg="3"
      columnEndLg="11"
    >
      {player}
    </GridItem>
  );
};

ComposableMediaPlayer.defaultProps = {
  theaterMode: false,
};

ComposableMediaPlayer.propTypes = {
  media: PropTypes.shape({
    mediaType: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  theaterMode: PropTypes.bool,
};

export default ComposableMediaPlayer;
